var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iInput',{attrs:{"icon":_vm.icon,"clearable":!_vm.icon,"size":"small"},on:{"on-change":function($event){_vm.onTyping()}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }